import { createApp } from "vue"
import App from "./App.vue"
import router from "./router"
import "./interceptors/axios"
import store from "./store"

import { FontAwesomeIcon } from "./plugins/font-awesome"
import PrimeVue from "primevue/config"
import Aura from "@primevue/themes/aura"

import DialogService from "primevue/dialogservice"
import ToastService from "primevue/toastservice"
import ConfirmationService from "primevue/confirmationservice"

import "bootstrap"
import "bootstrap/dist/css/bootstrap.min.css"

import "@/assets/styles.scss"
import "@/assets/tailwind.css"

const app = createApp(App)
app.use(router)
app.use(store)
app.use(PrimeVue, {
  theme: {
    preset: Aura,
    options: {
      darkModeSelector: ".app-dark",
    },
  },
})
app.use(ToastService)
app.use(DialogService)
app.use(ConfirmationService)
app.component("font-awesome-icon", FontAwesomeIcon)
app.mount("#app")
